import { getMomentTz, MESApiService } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import {
	HeatEventSummary,
	MillSalesSummary,
	ProductionEventSummary,
	SalesOverview,
	SalesOverviewResponse,
} from "../models/SalesOverview";

const moment = getMomentTz();

export const getSalesOverview = async (
	signal?: AbortSignal,
): Promise<SalesOverview> => {
	const apiService = new MESApiService();

	const resp = await apiService.callV2("[SWV].[GetSalesOverview]", [], signal);

	if (!resp.ok) {
		throw new Error(resp.message || "Error fetching sales overview");
	}

	const tables = get(
		resp,
		"data.tables",
		{},
	) as SalesOverviewResponse["tables"];

	const millRows = get(tables, "0.rows", []) as MillSalesSummary[];
	const eventRows = get(tables, "1.rows", []) as ProductionEventSummary[];
	const heatByEventRows = get(tables, "2.rows", []) as HeatEventSummary[];

	return {
		Mills: millRows.map((r) => ({
			...r,
			CurrentEventEnd: r.CurrentEventEnd
				? moment.utc(r.CurrentEventEnd).toDate()
				: null,
			CurrentRollingStart: r.CurrentRollingStart
				? moment.utc(r.CurrentRollingStart).toDate()
				: null,
			CurrentEventStart: r.CurrentEventStart
				? moment.utc(r.CurrentEventStart).toDate()
				: null,
			CurrentProjectedRollOut: r.CurrentProjectedRollOut
				? moment.utc(r.CurrentProjectedRollOut).toDate()
				: null,
			NextEventStart: r.NextEventStart
				? moment.utc(r.NextEventStart).toDate()
				: null,
			NextEventEnd: r.NextEventEnd ? moment.utc(r.NextEventEnd).toDate() : null,
			IsInDelay: Boolean(r.IsInDelay),
			IsPlaceholder: Boolean(r.IsPlaceholder),
		})),
		Events: eventRows.map((e) => ({
			...e,
			EventStart: moment.utc(e.EventStart).toDate(),
			EventEnd: e.EventEnd ? moment.utc(e.EventEnd).toDate() : null,
		})),
		HeatsByEvent: heatByEventRows.map((h) => ({
			...h,
			HeatStart: moment.utc(h.HeatStart).toDate(),
		})),
	};
};
